import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { Suspense, lazy } from 'react';
import ErrorPage from '../modules/error/ErrorPage';

const ItemSection = lazy(() => import('../modules/settings/items/ItemSection'));

const ItemRoutes = (
  <>
    <Route
      path="items"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <ItemSection />
        </Suspense>
      }
    />
  </>
);

export default ItemRoutes; 